export default "__VITE_ASSET__8JsHoCRv__"